import { KampaayDataProvider } from 'services/api/dataProvider'
import { Kampaayer } from 'services/api/entities/crm/kampaayers'
import { getDateAsString } from 'services/utils/date'
import { EntityDescriptor } from '.'

export const kampaayers: EntityDescriptor<Kampaayer> = {
  format: (_dataProvider?: KampaayDataProvider) => (record) => ({
    ID: record.id,
    Firstname: record.firstName,
    Lastname: record.lastName,
    Phone: record.phone,
    Email: record.email,
    'Birth Date': getDateAsString(record.birthDate),
    'Birth Place': record.birthPlace,
    'Personal Number': record.personalNumber,
    'Residence Address': record.residenceAddress,
    'Domicile Address': record.domicileAddress,
  }),
}
